import { IGetEligibility } from '../../../models/order-details/orderActions';
import {
  FULFILLMENT_TYPE,
  STATUS_CODE,
  CANCELLATION_STATUS,
} from '../../../constants/status';
import {
  IFulfillmentGroup,
  IOrderDetailsResponse,
} from '../../../models/order-details';
import { getOosRecoveryDrawerOptions } from '../../../utils/bopis/oos-recovery-options';
// TODO: Add more logics based on the requirements
//  Please define the fulfillment and status on status file do not use a direct string value.

// Some of the Self-Serive Buttons are not eligible for B2B account

export const getOrderStatus = (statusCode: number) => {
  const isProcessing = statusCode === STATUS_CODE.PROCESSING;
  const isShipped = statusCode === STATUS_CODE.SHIPPED;
  const isBackOrdered = statusCode === STATUS_CODE.BACKORDERED;
  const isInTransit = statusCode === STATUS_CODE.IN_TRANSIT;
  const isDeliveryAttempted = statusCode === STATUS_CODE.ATTEMPTED;
  const isDelivered = statusCode === STATUS_CODE.DELIVERED;
  const isOnItsWayToStore = statusCode === STATUS_CODE.ON_ITS_WAY_TO_STORE;
  const isOutForDelivery = statusCode === STATUS_CODE.OUT_FOR_DELIVERY;
  const isDFSOnSchedule = statusCode === STATUS_CODE.DFS_ON_SCHEDULE;
  const isArrivedAtStore = statusCode === STATUS_CODE.PREPARING_FOR_PICKUP;
  const isReadyForPickup = statusCode === STATUS_CODE.READY_FOR_PICKUP;
  const isOrderPickedup = statusCode === STATUS_CODE.COMPLETED;
  const isOrderCompleted = statusCode === STATUS_CODE.COMPLETED;
  const isReturnStarted = statusCode === STATUS_CODE.RETURN_IN_PROGRESS;
  const isReturned = statusCode === STATUS_CODE.RETURNED;
  const isCanceled = statusCode === STATUS_CODE.CANCELED;
  const isMAOnSchedule = statusCode === STATUS_CODE.MAJOR_APPLIANCE_ON_SCHEDULE;
  const isBOSSArrivedAndPickedUp =
    isArrivedAtStore || isReadyForPickup || isOrderPickedup;
  const isBODFSOnSchedule = statusCode === STATUS_CODE.BODFS_ON_SCHEDULE;

  const isStatusDeliveredOrOutForDelivery = isDelivered || isOutForDelivery;
  const isStatusDeliveredOrOrderPickedup = isDelivered || isOrderCompleted;
  const isArrivedAtStoreAndReadyForPickup =
    isArrivedAtStore || isReadyForPickup;
  /** for `MA`, `BODFS` and `DFS` orders */
  const isProcessingOrOnSchedule =
    isProcessing || isMAOnSchedule || isBODFSOnSchedule || isDFSOnSchedule;
  const isCancelledOrReturn = isCanceled || isReturned || isReturnStarted;

  return {
    isProcessing,
    isShipped,
    isBackOrdered,
    isInTransit,
    isDeliveryAttempted,
    isDelivered,
    isOutForDelivery,
    isDFSOnSchedule,
    isOnItsWayToStore,
    isArrivedAtStore,
    isReadyForPickup,
    isOrderCompleted,
    isReturnStarted,
    isReturned,
    isCanceled,
    isMAOnSchedule,
    isStatusDeliveredOrOutForDelivery,
    isStatusDeliveredOrOrderPickedup,
    isBOSSArrivedAndPickedUp,
    isArrivedAtStoreAndReadyForPickup,
    isBODFSOnSchedule,
    isProcessingOrOnSchedule,
    isCancelledOrReturn,
  };
};

//  if getOrderStatus or getFulfillmentStatus value is empty {} show the orderStatus not avaialble error alert

export interface IFulfillmentStatus {
  isSTH: boolean;
  isBOSS: boolean;
  isBOPIS: boolean;
  isMA: boolean;
  isBODFS: boolean;
  isDFS: boolean;
  isMisc: boolean;
  isFulfillmentSTHorBOSS: boolean;
  isFulfillmentBODFSorDFS: boolean;
  isFulfillmentMAorBODFSorDFS: boolean;
  isFulfillmentMethodExcludeBOPIS: boolean;
  isFulfillmentCurbsideEligible: boolean;
  isFulfillmentReturnEligible: boolean;
  isEligibleFulfillmentAAFESOrNex: boolean;
}

export const getFulfillmentStatus = (
  fulfillmentType: FULFILLMENT_TYPE | string,
): IFulfillmentStatus => {
  const isSTH = fulfillmentType === FULFILLMENT_TYPE.STH;
  const isBOSS = fulfillmentType === FULFILLMENT_TYPE.BOSS;
  const isBOPIS = fulfillmentType === FULFILLMENT_TYPE.BOPIS;
  const isMA = fulfillmentType === FULFILLMENT_TYPE.MA;
  const isBODFS = fulfillmentType === FULFILLMENT_TYPE.BODFS;
  const isDFS = fulfillmentType === FULFILLMENT_TYPE.DFS;
  const isMisc = fulfillmentType === FULFILLMENT_TYPE.MISC;
  const isEligibleFulfillmentAAFESOrNex = isMA;
  const isFulfillmentSTHorBOSS = isSTH || isBOSS;
  const isFulfillmentBODFSorDFS = isBODFS || isDFS;
  const isFulfillmentMAorBODFSorDFS = isMA || isFulfillmentBODFSorDFS; // Reschedule Eligible
  const isFulfillmentCurbsideEligible = isBOSS || isBOPIS;
  const isFulfillmentReturnEligible = isFulfillmentSTHorBOSS;
  const isFulfillmentMethodExcludeBOPIS =
    isFulfillmentSTHorBOSS || isFulfillmentBODFSorDFS || isMA; // for order Tracking

  return {
    isSTH,
    isBOSS,
    isBOPIS,
    isMA,
    isBODFS,
    isDFS,
    isMisc,
    isFulfillmentSTHorBOSS,
    isFulfillmentBODFSorDFS,
    isFulfillmentMAorBODFSorDFS,
    isFulfillmentMethodExcludeBOPIS,
    isFulfillmentCurbsideEligible,
    isFulfillmentReturnEligible,
    isEligibleFulfillmentAAFESOrNex,
  };
};

// TODO: ADD MISC TYPE OF FULFILLMENT once B2B and B2C APi is figured out

export const getOrderActionEligibility = (
  fulfillmentType: FULFILLMENT_TYPE,
  statusCode: STATUS_CODE,
): IGetEligibility => {
  const orderStatus = getOrderStatus(statusCode);
  const orderFulfillment = getFulfillmentStatus(fulfillmentType);
  const {
    isBOPIS,
    isFulfillmentSTHorBOSS,
    isFulfillmentMAorBODFSorDFS,
    isFulfillmentCurbsideEligible,
    isEligibleFulfillmentAAFESOrNex,
  } = orderFulfillment;
  const {
    isProcessing,
    isShipped,
    isBackOrdered,
    isReturnStarted,
    isDelivered,
    isDeliveryAttempted,
    isArrivedAtStore,
    isOutForDelivery,
    isReadyForPickup,
    isOrderCompleted,
    isStatusDeliveredOrOutForDelivery,
    isOnItsWayToStore,
    isArrivedAtStoreAndReadyForPickup,
    isBODFSOnSchedule,
    isProcessingOrOnSchedule,
  } = orderStatus;

  const isCancelEligibleForSTHorBOSS =
    isFulfillmentSTHorBOSS && (isProcessing || isBackOrdered); // for both remorse and post remorse
  const isRescheduleEligibleForMAorBODFSorDFS =
    isFulfillmentMAorBODFSorDFS && isProcessingOrOnSchedule; // On Schedule for MA, BODFS and DFS order
  const isPrintReturnAvailable = isFulfillmentSTHorBOSS && isReturnStarted;
  const isTrackingPrimaryForMAandBODFSandDFS =
    isFulfillmentMAorBODFSorDFS && isDelivered; // primary button for ma,bodfs and dfs for delivered order
  const isCurbsideEligible =
    isFulfillmentCurbsideEligible && (isReadyForPickup || isArrivedAtStore);
  const isTrackShipmentAvailable =
    ((isFulfillmentSTHorBOSS || isFulfillmentMAorBODFSorDFS) &&
      (isShipped || isStatusDeliveredOrOutForDelivery)) ||
    isTrackingPrimaryForMAandBODFSandDFS;
  const fulfillmentTypeEligibleForReturn =
    isFulfillmentSTHorBOSS &&
    (isShipped ||
      isDelivered ||
      isReadyForPickup ||
      isOrderCompleted ||
      isOnItsWayToStore ||
      isArrivedAtStore);

  const isBopisCancelEligible = isBOPIS && !isOrderCompleted;
  const isBopisArrivedAndReadyForPickUp = isArrivedAtStoreAndReadyForPickup;
  const isMAorBODFSorDFSCancelEligible =
    isFulfillmentMAorBODFSorDFS && !isOrderCompleted;
  const isTrackingEligibleForFulfillmentMethod = !isBOPIS;
  const isTrackingPrimaryForMAorBODFSorDFS =
    isFulfillmentMAorBODFSorDFS &&
    (isOutForDelivery ||
      isShipped ||
      isDeliveryAttempted ||
      isDelivered ||
      isBODFSOnSchedule);
  const isTrackingPrimaryForSTHorBOSS =
    isFulfillmentSTHorBOSS &&
    (isShipped || isOnItsWayToStore || isArrivedAtStore) &&
    !isCurbsideEligible;

  return {
    isCancelEligibleForSTHorBOSS,
    isPrintReturnAvailable,
    isTrackingPrimaryForMAandBODFSandDFS,
    isCurbsideEligible,
    isTrackShipmentAvailable,
    fulfillmentTypeEligibleForReturn,
    isRescheduleEligibleForMAorBODFSorDFS,
    isBopisCancelEligible,
    isMAorBODFSorDFSCancelEligible,
    isBopisArrivedAndReadyForPickUp,
    isTrackingEligibleForFulfillmentMethod,
    isTrackingPrimaryForMAorBODFSorDFS,
    isTrackingPrimaryForSTHorBOSS,
    isEligibleFulfillmentAAFESOrNex,
  };
};

// Looks through a list of fulfillment groups and returns true if the target fulfillment type exists
export const doesFulfillmentStatusExist = (
  targetFulfillmentType: FULFILLMENT_TYPE,
  fulfillmentGroups?: IFulfillmentGroup[],
) =>
  fulfillmentGroups?.some(
    (group) => group.fulfillmentType === targetFulfillmentType,
  );

export const isBopisOutOfStockRecoverable = (
  fulfillmentGroup: IFulfillmentGroup,
) => {
  return (
    fulfillmentGroup.cancellationStatus === CANCELLATION_STATUS.OUT_OF_STOCK &&
    fulfillmentGroup.actions?.isOosRecoveryEnabled &&
    getOosRecoveryDrawerOptions(fulfillmentGroup).length > 0
  );
};

export const getRemorseCancelType = (
  fulfillmentGroup: IFulfillmentGroup | undefined,
  orderDetailsData: IOrderDetailsResponse | undefined,
) => {
  if (!fulfillmentGroup || !orderDetailsData)
    return { isRemorseCancel: false, isPostRemorseCancel: false }; // Handle undefined cases

  const { isPostRemorse, actions, fulfillmentType, lineItems } =
    fulfillmentGroup;

  const canCancel = !!actions?.isCancelEnabled;
  const statusCode: STATUS_CODE = lineItems?.[0]?.statusCode ?? 0;

  const isPostRemorseCancelEnabled = isPostRemorse && canCancel;

  const isRemorseCancel = !isPostRemorse && canCancel;

  const isPostRemorseCancel =
    isPostRemorseCancelEnabled &&
    !orderDetailsData?.cancellationRequested &&
    ['ShipToHome', 'BuyOnlineShipToStore'].includes(fulfillmentType) &&
    statusCode !== 102;

  return { isRemorseCancel, isPostRemorseCancel };
};
